import React, { useState, useEffect, useRef } from 'react';
import Modal from '../../Modal';

const EditorReviewFilesModal = ({setFiles, initialFile=null, articleId, whiteList}) => {

  const [description, setDescription] = useState("");
  const [file, setFile] = useState(initialFile || null);
  const [errorMessage, setErrorMessage] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [whitelistExtension] = useState(whiteList);

  const triggerRef = useRef(null);

  useEffect(() => {
    $(document).foundation("reflow");
  }, []);

  useEffect(() => {
    if (file instanceof File && handleFileTypeErrorMessage().length > 0) {
      setDisabled(true);
    } else if (file instanceof File && handleFileTypeErrorMessage().length == 0) {
      setDisabled(false);
    }
  }, [file])

  const handleFileTypeErrorMessage = () => {
    let msg = isCorrectFileExtension() ? "" : 'This is not an accepted file type.';
    setErrorMessage(msg);
    return msg;
  }

  const isCorrectFileExtension = () => {
    if (!file) return true;
    let ext = file.name.split(".").pop();
    return whitelistExtension.includes(ext.toUpperCase()) ? true : false;
  }

  const createFormData = () => {
    let formData = new FormData();

    formData.append('content_file', file); 
    formData.append('description', description || '');
    formData.append('article_id', articleId);

    return formData;
  }

  const handleCreateEditorReviewFile = () => {
    setDisabled(true);
    setLoading(true);
    fetch(`/publish/articles/${articleId}/editor_review_files`, {
      method: 'POST',
      body: createFormData(),
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": $("[name='csrf-token']").attr("content"),
        'Accept': 'application/json'
      },
    }).then((res) => res.json())
    .then((data) => {
      // clears tooltip lingering problem
      const $el = $(triggerRef.current);
      try { $el.trigger('mouseleave'); } catch (e) {}
      const id = $el.attr('aria-describedby');
      if (id) { $(`#${id}`).remove(); $el.removeAttr('aria-describedby'); }

      setFiles(data.content_files);
      Modal.close();
    })
  }

  const onFileInput = (e) => {
    const selected = e.target.files?.[0];
    if (selected) {
      const maxFileSize = 25;
      const maxFileSizeInBytes = maxFileSize * 1000000;
      if (selected.size > maxFileSizeInBytes) {
        setErrorMessage(`File size exceeds ${maxFileSize}MB limit.`);
        setFile(null);
        return;
      } else {
        setFile(e.target.files?.[0]);
        setDisabled(false);
      }
    }
  }

  const renderButtonText = () => {
    return loading ? "UPLOADING..." : "ADD";
  }

  return (
    <div id={"editor-review-files-reveal-modal"} className="reveal-modal new-modal editor-review-files-modal middling large-12 columns" data-reveal>
      <div className="modal-body editor-review-files-section">
        <div className="modal-close">
          <a href='#' className='cancel-modal'>
            <img src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>
        <div className="modal-content middling">
          <div className="modal-header text-center">
            <h5>Upload a file</h5>
            <hr/>
          </div>
          <div className="row">
            <div className="large-12 columns">
              <h5>Upload File for Editorial Review Only</h5>
              <p>Please upload any documentation needed to address consent or licensing issues relevant to your article.</p>
            </div>
          </div>
          <div className="row">
            <div className="large-12 columns">
              <div className="input-container">
                <label>Description (optional)</label>
                <input type="text" name="description" onChange={(e) => setDescription(e.target.value)} value={description} />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="large-12 columns">
              <div className="file-upload-container">
                <div>File</div>
                <img
                  ref={triggerRef}
                  className="file-tool-tip tip-top"
                  src="https://public.cureus.com/homepage_new/question_mark.png"
                  data-tooltip=""
                  title={whitelistExtension.join(", ")}
                />
                <label className='file-content-label' htmlFor="file-content-input">Choose File</label>
                <input
                  id="file-content-input"
                  type="file"
                  style={{display: 'none'}}
                  onChange={(e) => onFileInput(e)}
                />
                <div className="selected-file" aria-live="polite">
                  {file ? `${file.name}` : 'No file chosen'}
                </div>
              </div>
              {errorMessage.length > 0 && <span className='file-error-msg'>{errorMessage}</span>}
            </div>
          </div>
          <div className="modal-footer">
            <button className="button add-btn" disabled={disabled} onClick={handleCreateEditorReviewFile}>{renderButtonText()}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditorReviewFilesModal;